import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { initCal } from "./utils/cal";
initCal();
render(<App data-id="element-258" data-mp="1wbd080vlbrii" />, document.getElementById("root"));